const Stars = (props: { color: string }) => {
	return (
		<svg
			width='59'
			height='64'
			viewBox='0 0 59 64'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M0 14.2222L5.17188 17.0952L8 22.3492L10.8281 17.0952L16 14.2222L10.8281 11.3492L8 6.09521L5.17188 11.3492L0 14.2222Z'
				fill={props.color}
			/>
			<path
				d='M8 56.8889L13.1719 59.4028L16 64.0001L18.8281 59.4028L24 56.8889L18.8281 54.3751L16 49.7778L13.1719 54.3751L8 56.8889Z'
				fill={props.color}
			/>
			<path
				d='M42 7.11111L47.4951 9.625L50.5 14.2222L53.5049 9.625L59 7.11111L53.5049 4.59723L50.5 0L47.4951 4.59723L42 7.11111Z'
				fill={props.color}
			/>
		</svg>
	);
};

export default Stars;
